import {CreatorRow as CreatorEntity} from "./creator-row"
import {formatDateOrYear} from "../datepicker/custom-datepicker"
import {DateOrYear} from "../datepicker/date-or-year"


class Family extends CreatorEntity {
    husbandId?: string
    wifeId?: string
    marriaged?: boolean = true
    marriageDate?: DateOrYear | any
    marriagePlace?: string
    divorced?: boolean = false
    notes?: string
    // GEDCOM bindings
    children: Set<string> = new Set()

    constructor(params: {
        id: string
        husbandId?: string
        wifeId?: string
        [key: string]: any
    }) {
        super(params)
        Object.assign(this, params)
    }

    asGedcom(): string {
        let gedcom = `0 @${this.id}@ FAM\n`
        if (!this.enabled) gedcom += `1 _ENABLED ${this.enabled}\n`

        gedcom += `1 HUSB @${this.husbandId}@\n`
        gedcom += `1 WIFE @${this.wifeId}@\n`
        if (this.marriaged) {
            gedcom += `1 MARR\n`
            if (this.marriageDate) gedcom += `2 DATE ${formatDateOrYear(this.marriageDate)}\n`
            if (this.marriagePlace) gedcom += `2 PLAC ${this.marriagePlace}\n`
        } else {
            gedcom += `1 MARS\n`
            gedcom += `2 TYPE "Common Law"\n`
        }
        for (const childId of this.children) {
            gedcom += `1 CHIL @${childId}@\n`
        }
        if (this.divorced) {
            gedcom += `1 DIV\n`
        }
        if (this.notes) {
            gedcom += `1 NOTE ${this.notes}\n`
        }
        return gedcom
    }
}

export class I18nFamily extends Family {
    static prefix = "F"
    static empty = (id: number): Family => new I18nFamily({ id: `${this.prefix}${id}` })
}


// noinspection JSUnusedGlobalSymbols
export class FamilyBindings extends I18nFamily {

    constructor(obj: any) {
        super({ id: obj.id })
        Object.assign(this, obj)
    }

    /**
     * Supplementary bindings for anti tampering checks after import.
     */
    _children: Set<string> = new Set()
}